import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../components/common/PageTitle";
import "../assets/styling/Styles.css";
import "./Styles.css";
import CropList from "./CropList";
import IrrigationList from "./IrrigationList";
import ZoneList from "./ZoneList";
import FieldsStore from "../FieldsStore";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import api from "../api/api";
import { withTranslation } from "react-i18next";
import FieldList from "./FieldList";
import FarmList from "./FarmList";
import "./AddField.css";

class AddField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      elemValue: "farm",
      farms: [],
      zones: [],
      crops: [],
      irrigation: [],
      irrigationsData: [],
      farmsData: [],
      zonesData: [],
      cropsData: [],
      listSoils: [],
    };
  }

  ToWaterBalancePage = () => {
    window.location.href = "/Bilan";
  };

 // Fixed getDataZones
getDataZones = async () => {
  await api.get("/zone/zones").then((res) => {
    const newDataZone = res.data;
    this.setState({ zones: newDataZone.farms });
    let Zones = [];
    newDataZone.farms.map((item) => {  // ✅ Use newDataZone.farms
      let fields = item.fields;
      if (fields) {
        fields.map((itemZone) => {
          let zones = itemZone.zones;
          if (zones) {
            zones.map((i) => {
              Zones.push({
                Id: i.id,
                name: i.name,
                Uid: i.uid,
                source: i.source,
                description: i.description,
                depth_data: i.depth_data,
                field_id: i.field_id,
              });
            });
          }
        });
      }
    });
    this.setState({ zonesData: Zones });
  });
};

// Fixed getDataCrops
getDataCrops = async () => {
  try {
    const res = await api.get("/crop/crops");
    const newDataCrop = res.data;

    const Crops = [];

    newDataCrop.farms.forEach((item) => {  // ✅ Use newDataCrop.farms
      const fields = item.fields || [];
      fields.forEach((itemCrop) => {
        const crops = itemCrop.crops || [];
        crops.forEach((i) => {
          Crops.push({
            type: i.croptype_id,
            croptype: i.croptypes,
            address: i.address,
            Uid: i.uid,
            irrigations: i.irrigations,
            Id: i.id,
            field_id: i.field_id,
            zone_id: i.zone_id,
            rootDepth: i.rootDepth,
            growingDate: i.growingDate,
          });
        });
      });
    });

    this.setState({
      crops: newDataCrop.farms,
      cropsData: Crops,
    });
  } catch (error) {
    console.error("❌ Error fetching crop data:", error);
  }
};

// Fixed getDataIrrigations
getDataIrrigations = async () => {
  try {
    const res = await api.get("/irrigation/irrigations");
    const newDataIrrig = res.data;
    
    this.setState({ irrigation: newDataIrrig });

    let irrigationsData = [];

    // ✅ Use newDataIrrig directly
    newDataIrrig.forEach((item) => {
      const fields = item.fields;
      if (fields) {
        fields.forEach((field) => {
          const crops = field.crops;
          if (crops) {
            crops.forEach((crop) => {
              const irrigations = crop.irrigations;
              if (irrigations) {
                irrigations.forEach((irrigation) => {
                  irrigationsData.push({
                    type: irrigation.type,
                    address: irrigation.address,
                    pivotShape: irrigation.pivot_shape,
                    flowrate: irrigation.flowrate,
                    lateral: irrigation.lateral,
                    Uid: irrigation.uid,
                    crop_id: irrigation.crop_id,
                    zone_id: irrigation.zone_id,
                  });
                });
              }
            });
          }
        });
      }
    });

    this.setState({ irrigationsData });
  } catch (error) {
    console.error("Error fetching irrigations data: ", error);
  }
};

// Fixed getDataFields
getDataFields = async () => {
  await api.get("/field/fields").then((res) => {
    const newData = res.data;
    this.setState({ farms: newData.farms });
    let Fields = [];
    newData.farms.map((item) => {  // ✅ Use newData.farms
      let fields = item.fields;
      if (fields) {
        fields.map((itemfield) => {
          Fields.push({
            title: itemfield.name,
            status: itemfield.status,
            description: itemfield.description,
            Uid: itemfield.uid,
            farm_id: itemfield.farm_id,
            Latitude: itemfield.Latitude,
            Longitude: itemfield.Longitude,
            Id: itemfield.id,
          });
        });
      }
    });
    this.setState({ farmsData: Fields });
    FieldsStore.setFields(Fields);
  });
};

  getSoils = async () => {
    try {
      await api
        .get("/soils/get-soils")
        .then((response) => {
          this.setState({ listSoils: response.data.Soils });
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };
  componentDidMount = async () => {
    this.getDataFields();
    this.getDataZones();
    this.getDataCrops();
    this.getDataIrrigations();
    this.getSoils();
  };

  handleFarmDeleted = async () => {
    await this.getDataFields();
    await this.getDataZones();
    await this.getDataCrops();
    await this.getDataIrrigations();
  };

  refreshCrops = async () => {
    await this.getDataCrops();
  };

  render() {
    const { t } = this.props;
    const renderAddSetup = () => {
      switch (this.state.elemValue) {
        case "farm":
          return (
            <div>
              <Card small className="h-100">
                <Card.Header className="border-bottom">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "auto",
                      float: "left",
                    }}
                  >
                    <div>
                      <h6 className="m-0" style={{ textAlign: "left" }}>
                        {t("farm_setup")}
                      </h6>{" "}
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="pt-0">
                  <Row noGutters className="page-header py-4">
                    <PageTitle
                      sm="4"
                      title={t("my_farms")}
                      className="text-sm-left"
                    />
                  </Row>
                  <Row className="px-2">
                    <FarmList
                      Fields={this.getDataFields}
                      farmList={this.state.farms}
                      onFarmDeleted={this.handleFarmDeleted}
                    />
                  </Row>
                </Card.Body>
              </Card>
            </div>
          );
        case "field":
          return (
            <div>
              <Card small className="h-100">
                <Card.Header className="border-bottom">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "auto",
                      float: "left",
                    }}
                  >
                    <div>
                      <h6 className="m-0" style={{ textAlign: "left" }}>
                        {t("field_setup")}
                      </h6>{" "}
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="pt-0">
                  <Row noGutters className="page-header py-4">
                    <PageTitle
                      sm="4"
                      title={t("my_fields")}
                      className="text-sm-left"
                    />
                  </Row>
                  <Row className="px-2">
                    <FieldList
                      Fields={this.getDataFields}
                      FieldsList={FieldsStore.getFields()}
                    />
                  </Row>
                </Card.Body>
              </Card>
            </div>
          );
        case "soil":
          return (
            <div>
              <Card small className="h-100">
                <Card.Header className="border-bottom">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h6 className="m-0">{t("soil_info")}</h6>
                  </div>
                </Card.Header>
                <Card.Body className="pt-0">
                  <Row noGutters className="page-header py-4">
                    <PageTitle
                      sm="4"
                      title={t("my_zones")}
                      className="text-sm-left"
                    />
                  </Row>
                  <Row className="px-2">
                    <ZoneList
                      zonesList={this.state.zonesData}
                      Zones={this.getDataZones}
                      Fields={this.state.farmsData}
                      listSoils={this.state.listSoils}
                    />
                  </Row>
                </Card.Body>
              </Card>
            </div>
          );
        case "crop":
          return (
            <div>
              <Card small className="h-100">
                <Card.Header className="border-bottom">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h6 className="m-0">{t("crop_info")}</h6>{" "}
                  </div>
                </Card.Header>
                <Card.Body className="pt-0">
                  <Row noGutters className="page-header py-4">
                    <PageTitle
                      sm="4"
                      title={t("my_crops")}
                      className="text-sm-left"
                    />
                  </Row>
                  <Row className="px-2">
                    <CropList
                      cropsList={this.state.cropsData}
                      Crops={this.getDataCrops}
                      Fields={this.state.farmsData}
                      Zones={this.state.zonesData}
                      refreshCrops={this.refreshCrops}
                    />
                  </Row>
                </Card.Body>
              </Card>
            </div>
          );
        case "irrig":
          return (
            <div>
              <Card small className="h-100">
                <Card.Header className="border-bottom">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h6 className="m-0">{t("Irrigation_info")}</h6>{" "}
                  </div>
                </Card.Header>
                <Card.Body className="pt-0">
                  <Row noGutters className="page-header py-4">
                    <PageTitle
                      sm="4"
                      title={t("my_irrigations")}
                      className="text-sm-left"
                    />
                  </Row>
                  <Row className="px-2">
                    <IrrigationList
                      irrigationsList={this.state.irrigationsData}
                      Irrigations={this.getDataIrrigations}
                      Crops={this.state.cropsData}
                      Zones={this.state.zonesData}
                    />
                  </Row>
                </Card.Body>
              </Card>
            </div>
          );
        default:
          return null;
      }
    };
    return (
      <Container fluid className="field-settings-page">
        <header className="field-settings-header">
          <div>
            <span className="field-settings-eyebrow">SMARTFARM</span>
            <h1>{t("field_settings", { defaultValue: "Field settings" })}</h1>
            <p>
              {t("field_settings_subtitle", {
                defaultValue:
                  "Manage farms, field boundaries, soil, crops and irrigation from one workspace.",
              })}
            </p>
          </div>
          <div className="field-settings-progress">
            <span>{t("overview")}</span>
            <strong>{t(`${this.state.elemValue}_setup`, { defaultValue: this.state.elemValue })}</strong>
          </div>
        </header>

        <Row>
          <Col lg="12" md="12" sm="12" className="mb-4">
            <Row className=" d-flex justify-content-center align-items-center py-2">
              <Col lg="12" md="12" sm="12">
                <Container fluid className="field-settings-toolbar">
                  <div className="d-flex justify-content-end">
                    <Dropdown className="field-settings-add-menu">
                      <Dropdown.Toggle id="field-settings-add" className="field-settings-add-button">
                        <i className="fas fa-plus" aria-hidden="true" />
                        <span>{t("add_element")}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item as={Link} to="/add-farm">
                          <i className="fas fa-tractor" aria-hidden="true" />
                          {t("add_farm")}
                        </Dropdown.Item>

                        <Dropdown.Item as={Link} to="/add-field">
                          <i className="fas fa-vector-square" aria-hidden="true" />
                          {t("add_field")}
                        </Dropdown.Item>

                        <Dropdown.Item as={Link} to="/add-soil-info">
                          <i className="fas fa-layer-group" aria-hidden="true" />
                          {t("add_zone")}
                        </Dropdown.Item>

                        <Dropdown.Item as={Link} to="/add-crop-info">
                          <i className="fas fa-seedling" aria-hidden="true" />
                          {t("add_crop")}
                        </Dropdown.Item>

                        <Dropdown.Item as={Link} to="/add-irrigation">
                          <i className="fas fa-tint" aria-hidden="true" />
                          {t("add_irrig")}
                        </Dropdown.Item>

                        <Dropdown.Item onClick={this.ToWaterBalancePage}>
                          <i className="fas fa-chart-line" aria-hidden="true" />
                          {t("water_balance")}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Container>
                <Nav tabs className="field-settings-tabs" role="tablist">
                  <NavItem>
                    <NavLink
                      id="farm"
                      role="tab"
                      aria-selected={this.state.elemValue === "farm"}
                      onClick={(e) => { e.preventDefault(); this.setState({ elemValue: "farm" }); }}
                      className={`${
                        this.state.elemValue === "farm"
                          ? "bg-info rounded text-dark "
                          : "rounded text-dark "
                      }`}
                      href="#"
                    >
                      <i className="fas fa-tractor" aria-hidden="true" />
                      <span>{t("farm_setup")}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      id="field"
                      role="tab"
                      aria-selected={this.state.elemValue === "field"}
                      onClick={(e) => { e.preventDefault(); this.setState({ elemValue: "field" }); }}
                      className={`${
                        this.state.elemValue === "field"
                          ? "bg-info rounded text-dark "
                          : "rounded text-dark "
                      }`}
                      href="#"
                    >
                      <i className="fas fa-vector-square" aria-hidden="true" />
                      <span>{t("field_setup")}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      id="soil"
                      role="tab"
                      aria-selected={this.state.elemValue === "soil"}
                      onClick={(e) => { e.preventDefault(); this.setState({ elemValue: "soil" }); }}
                      className={`${
                        this.state.elemValue === "soil"
                          ? "bg-info rounded text-dark "
                          : "rounded text-dark"
                      }`}
                      href="#"
                    >
                      <i className="fas fa-layer-group" aria-hidden="true" />
                      <span>{t("soil_info")}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      id="crop"
                      role="tab"
                      aria-selected={this.state.elemValue === "crop"}
                      onClick={(e) => { e.preventDefault(); this.setState({ elemValue: "crop" }); }}
                      className={`${
                        this.state.elemValue === "crop"
                          ? "bg-info rounded text-dark "
                          : "rounded text-dark"
                      }`}
                      href="#"
                    >
                      <i className="fas fa-seedling" aria-hidden="true" />
                      <span>{t("crop_info")}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      id="irrig"
                      role="tab"
                      aria-selected={this.state.elemValue === "irrig"}
                      onClick={(e) => { e.preventDefault(); this.setState({ elemValue: "irrig" }); }}
                      className={`${
                        this.state.elemValue === "irrig"
                          ? "bg-info rounded text-dark"
                          : "rounded text-dark"
                      }`}
                      href="#"
                    >
                      <i className="fas fa-tint" aria-hidden="true" />
                      <span>{t("Irrigation_info")}</span>
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
            {renderAddSetup()}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withTranslation()(AddField);
